// extracted by mini-css-extract-plugin
module.exports = {"pendingTasks":"styles_pendingTasks__kGGFw"};